import { NavLink } from 'react-router';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

interface CardItemProps {
  title: string;
  content: string;
  footer: string;
  navigationLink: string;
}
export const CardItem = ({ title, content, footer, navigationLink }: CardItemProps) => {
  return (
    <Card className="">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <p>{content}</p>
      </CardContent>
      <CardFooter>
        <p>
          <NavLink to={navigationLink} className="text-deep-blue">
            {footer}
          </NavLink>
        </p>
      </CardFooter>
    </Card>
  );
};
